import { useState } from 'react';
import { ModuleType } from 'infrastructure/enums';

import type { ProviderDashboardTab } from 'components/organisms/provider-dashboard';

export const useProviderDashboardTab = () => {
  const [activeTab, setActiveTab] = useState<ProviderDashboardTab>('summary');
  const [module, setModule] = useState(ModuleType.RPM);
  const [providersPage, setProvidersPage] = useState(1);
  const providersPageSize = 10;

  return {
    activeTab,
    onTabChange: setActiveTab,
    providersPage,
    providersPageSize,
    onPageChange: setProvidersPage,
    module,
    setModule,
  };
};
